const startCountdown = () => {
    let count = 5;
    const el = document.getElementById('js-countdown');
    if (!el) return;

    const timer = setInterval(() => {
        count--;
        if (count <= 0) {
            clearInterval(timer);
            return;
        }
        el.textContent = count;
    }, 1000);
};

const main = () => {
    if (document.querySelector('#page-error') == null) return;
    startCountdown();
};

export default main;
